/** Map any spelling/case/legacy to canonical: SHARE | CALL | PUT */
export function normalizeType(t?: string | null): "SHARE" | "CALL" | "PUT" {
    const s = (t ?? "").trim().toUpperCase();
    if (s === "SHARE" || s === "SHARES" || s === "STOCK" || s === "COMMON" || s === "EQUITY") return "SHARE";
    if (s === "CALL" || s === "CALLS") return "CALL";
    if (s === "PUT" || s === "PUTS") return "PUT";
    // default to SHARE so we don't hide anything if an odd value sneaks in
    return "SHARE";
}

/** Parse a "YYYY-Qn" string into { year, quarterNumber } */
export function parseYearQuarter(s: string): { year: number; quarterNumber: 1 | 2 | 3 | 4 } {
    if (!s) return {year: NaN, quarterNumber: 1};
    const cleaned = s.replace("-", "");
    const year = Number(cleaned.slice(0, 4));
    const q = Number(cleaned.replace(/.*Q/, ""));
    const quarterNumber = (q === 1 || q === 2 || q === 3 || q === 4 ? q : 1) as 1 | 2 | 3 | 4;
    return {year, quarterNumber};
}
